var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyChatDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "property-chat-dm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "property-chat-dm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(25.000000, 25.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14076366,13 C8.51415721,14.0311675 8.16301036,15.1873732 8.16301036,16.4086066 C8.16301036,18.7612989 9.46624228,20.8726504 11.5315506,22.3135913 C11.7788139,22.4861039 11.3812098,23.1109516 10.5230233,24.3424779 C9.66483676,25.5740042 7.83935075,25.8329013 8.16301036,25.9766186 C8.44659607,26.1025415 11.3753138,25.7069406 13.0975828,25.1003403 C14.791469,24.5037366 15.4007087,23.981151 15.4195164,23.9852935 C15.4368236,23.9891056 15.4541498,23.9928814 15.4714949,23.9966207 C16.3026134,24.1757991 17.1771378,24.2714283 18.0798323,24.2714283 C21.3158897,24.2714283 24.1899219,23.0424574 26,21.1410588",
    id: "Path",
    strokeLinecap: "round",
    transform: "translate(17.062500, 19.500000) scale(-1, 1) translate(-17.062500, -19.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.396758,17.5688248 C17.6669804,17.5688248 22.75,13.6359094 22.75,8.7844124 C22.75,3.9329154 17.6669804,0 11.396758,0 C5.12653561,0 0.0435160345,3.9329154 0.0435160345,8.7844124 C0.0435160345,11.4128606 1.53551694,13.7716807 3.89997858,15.3815123 C4.18305724,15.5742449 3.72786139,16.2723302 2.74536929,17.648202 C1.7628772,19.0240738 -0.327024632,19.3133159 0.0435160345,19.4738781 C0.36817824,19.6145603 3.72111139,19.1725915 5.69284558,18.4948924 C7.63208579,17.8283616 8.32957196,17.2445244 8.3511039,17.2491525 C8.37091795,17.2534114 8.39075379,17.2576297 8.41061129,17.2618074 C9.36211463,17.461987 10.3633111,17.5688248 11.396758,17.5688248 Z",
    id: "Oval"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyChatDm);
export default __webpack_public_path__ + "static/media/property-chat-dm.116f0e6a947e1853b5072350da9be6bc.svg";
export { ForwardRef as ReactComponent };